import habitat from "preact-habitat";
import Main from "./components/Main";
import './tailwind.css'

if (window.location.pathname === '/search') {
  document.body.style.visibility =  'hidden';
}

let _habitat = habitat(Main);

_habitat.render({
  selector: '[data-widget-host="habitat"]',
  clean: true
});




// WEBPACK FOOTER //
// ./index.js